import React from "react";
import InputField from "./InputField";

const CpcInputField = ({
  value,
  onChange,
  placeholder,
  error,
  label,
  disabled,
  readonly,
  name
}) => {
  return (
    <InputField
      value={value}
      onChange={onChange}
      className="input-field__cpc"
      placeholder={placeholder}
      forceError={error}
      label={label}
      disabled={disabled}
      readonly={readonly}
      name={name}
    />
  );
};

export default CpcInputField;
